import React, { useEffect, useState, useContext, useRef } from 'react';
import { Card, CardBody } from "reactstrap";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { endpoint, pages } from '../../../../common/constant';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast, failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { PermissionContext, RolePermissions } from "../../../../../../../appContext";
import { checkPermission, fetchAllPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { PermisionDenied } from "../../../../common/commonComponents";
import { DisplayViewData, getAuditDetails } from '../common';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { sapDetail, tabFilledHandler } from '../constant';
import { checkValidations, getLatestUpdateInfo, getReqObj, initialForm } from './constant';
import SapLogsListing from './SapLogsListing';
import ALoader from 'views/pages/manage/common/a-loader';
import VendorDetailPopup from './VendorDetailsPopup';
import { getVendorDetailsByBuId } from './utils';

const ThirdPartyMapping = ({
    selectedTabValue,
    buId,
    action,
    isEdit,
    setIsEdit,
    setFilled,
    fetchBusinessAreaDetails,
    basicDetail
}) => {

    const permissions = useContext(PermissionContext);
    const userPermissions = RolePermissions(permissions, pages['businessAreaContactDetails']['id']);
    const isUpdatePermission = checkPermission(userPermissions, 'U');
    const isCreatePermission = checkPermission(userPermissions, 'C');

    const [loader, setLoader] = useState(false);
    const [form, setForm] = useState(initialForm);
    const [rows, setRows] = useState([]);
    const [prevData, setPrevData] = useState({});
    const isFirstRender = useRef(true);

    const [vendorDetailInfo, setVendorDetailInfo] = useState(false);
    const [vendorGlobalForm, setVendorGlobalForm] = useState({});
   const isSubContractor = (basicDetail?.businessUnitType?.[0]?.label) === 'SubContractor';

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (buId) getDetails();
            return;
        }
        if (buId && selectedTabValue?.key === "sapDetail") {
            getDetails();
        }
    }, [buId, selectedTabValue?.key]);

    const checkFilled = (data) => {
        tabFilledHandler(setFilled, 'sapDetail', !!data?.sapPlantId);
    };

    const getDetails = async () => {
        try {
            setLoader(true);

            const url1 = `${endpoint.businessArea.getBusinessAreaByIdV2}/${buId}`;
            const url2 = `${endpoint.businessArea.getThirdPartyStatusByBusinessAreaId}/${buId}`;

            // ✅ ADDED vendor API
            const [businessData, thirdPartyData, vendorData] = await Promise.all([
                fetchAllPromisedData(url1),
                fetchAllPromisedData(url2),
                getVendorDetailsByBuId(buId)
            ]);

            setForm(businessData);

            setRows((thirdPartyData?.thirdPartyList ?? []).map((item, index) => ({
                ...item,
                srNo: index + 1
            })));

            // ✅ store vendor globally
            if (vendorData) {
                setVendorGlobalForm(vendorData || {});
            }

            action === 'edit' && checkFilled(businessData);

        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };

    const editHandler = () => {
        if (isEdit) {
            failureToast(saveOrDeleteMsg);
        } else {
            setIsEdit(true);
            setPrevData(form);
        }
    };

    const cancelHandler = () => {
        setForm(prevData);
        setIsEdit(false);
    };

    if (selectedTabValue?.id != 4) return null;

    const saveHandler = async () => {

       if(!checkValidations(form, isSubContractor, vendorGlobalForm)) {
          return;
       }

        try {
            setLoader(true);  
            const req = getReqObj({ ...form, buId, vendorDetails: vendorGlobalForm, businessUnitType: basicDetail?.businessUnitType?.[0]?.label });

            const url = endpoint.businessArea.syncSAPDetailsWithBusinessArea;

            const data = await fetchAllPostPromisedData(url, req);

            if (data?.code === 200) {
                successToast(data?.message);

                if (action !== 'new') {
                    setIsEdit(false);
                    await getDetails();
                }

                if (action === 'new') {
                    tabFilledHandler(setFilled, 'sapDetail', true);
                }

                fetchBusinessAreaDetails();
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoader(false);
        }
    };

 
const latestDate = getLatestUpdateInfo(
    rows?.length > 0 ? rows[0] : null,   // third party logs
    form,                                // SAP form
    vendorGlobalForm                     // vendor details
);

const vendorPopuopHandler = () => {

    setVendorDetailInfo({
        ...vendorGlobalForm,
        businessAreaId: form?.id,
        businessAreaCode: form?.businessAreaKey
    });
};

    return (
        userPermissions ?
            <>
                {loader && <ALoader position='fixed' />}

                <Card className='ml-0'>
                    <CardBody>

                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='large-text color-grey-80'>Third party mapping</div>

                            {action != 'view' ? action == 'new' ?
                                <AButton
                                    variant="primary_filled"
                                    onClick={saveHandler}
                                    disabled={(action === 'new' && !isCreatePermission)}
                                >
                                    Save
                                </AButton>
                                :
                                (!isEdit) ?
                                    <AButton
                                        variant="outline"
                                        onClick={editHandler}
                                        disabled={!isUpdatePermission}
                                    >
                                        Edit
                                    </AButton>
                                    :
                                    <div>
                                        <AButton
                                            variant="primary_filled"
                                            onClick={saveHandler}
                                        >
                                            Save changes
                                        </AButton>

                                        <AButton
                                            variant="danger_filled"
                                            onClick={cancelHandler}
                                        >
                                            Cancel
                                        </AButton>
                                    </div>
                                : null}
                        </div>

                        <div className='mt-24 mx-0' style={{ borderBottom: "1px solid #E2E2E2" }}></div>

                        <DisplayViewData
                            dataArray={sapDetail({ vendorPopuopHandler , isSubContractor }) ?? []}
                            heading='Plant mapping'
                            isEdit={isEdit || action == 'new'}
                            action={action}
                            rowFormHandler={(key, val) => {
                                setForm({ ...form, [key]: val });
                            }}
                            form={form}
                            setForm={setForm}
                        />

                        {vendorDetailInfo && (
                            <VendorDetailPopup
                                open={vendorDetailInfo}
                                onClose={() => setVendorDetailInfo(false)}
                                vendorDetails={vendorDetailInfo}
                                setGlobalVendorForm={setVendorGlobalForm}
                                isEdit={isEdit || action == 'new'}
                                action={action}
                            />
                        )}

                        <div className='mt-24 mx-0' style={{ border: '1px solid #E2E2E2' }}>
                            <SapLogsListing rows={rows} />
                        </div>

                        {latestDate && getAuditDetails(latestDate.updatedBy, latestDate.updatedOn)}

                    </CardBody>
                </Card>
            </>
            :
            <PermisionDenied />
    );
};

export default ThirdPartyMapping;